export default __webpack_public_path__ + "static/media/trash.df480751.svg";